export const openlink = (url) => {
  window.open(url);
};

export const findDomPosition = (element) => {
  var currentPosition = 0;
  if (element.offsetParent) {
    do {
      currentPosition += element.offsetTop;
      element = element.offsetParent;
    } while (element);
    return [currentPosition];
  }
};

export const scrollToDiv = (id) => {
  window.scrollTo({
    top: findDomPosition(document.getElementById(id)),
    behavior: "smooth",
  });
};

export const showNotification = ({ toastRef, message, type }) => {
  toastRef.current.show({
    severity: type,
    detail: message,
    life: 2500,
  });
};

export const getCurrentTime = () => {
  const now = new Date();
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short",
  };
  const currentDisplayTime = now.toLocaleString("en-US", options);

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const currentFormattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  return [currentFormattedTime, currentDisplayTime];
};
